// ButtonContext.js
import React, { createContext, useContext } from 'react';

// Create context
const ButtonContext = createContext();

// ButtonProvider component
export const ButtonProvider = ({ children }) => {
  const Button = ({ label, onClick, style }) => (
    <button onClick={onClick} style={style}>
      {label}
    </button>
  );

  return (
    <ButtonContext.Provider value={{ Button }}>
      {children}
    </ButtonContext.Provider>
  );
};

// Custom hook for easy access
export const useButton = () => useContext(ButtonContext);
